import { IThunkActionCreator } from '../../../types/store';
import { getSeoMarkedList } from '../../../api/getSeoMarkedList';
import { getVillageListSummary } from '../../../api/getVillageListSummary';
import { formatMarkedList } from '../../../utils/seo';
import { IMarkedList } from '../../../types/seo';
import { IGetVillageListRequestSchema } from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';

export enum MarkedListActionTypes {
  Fetched = 'MarkedListFetched',
}

export interface IMarkedListFetched {
  data?: IMarkedList;
  type: MarkedListActionTypes.Fetched;
}

export function fetchMarkedList(queryString: string, filters: IGetVillageListRequestSchema): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger }) => {
    if (!queryString) {
      dispatch<IMarkedListFetched>({
        data: undefined,
        type: MarkedListActionTypes.Fetched,
      });

      return;
    }

    const [markedList, villageListSummary] = await Promise.all([
      getSeoMarkedList(httpApi, logger, { queryString }),
      getVillageListSummary(httpApi, logger, filters),
    ]);

    if (!markedList || !villageListSummary) {
      dispatch<IMarkedListFetched>({
        data: undefined,
        type: MarkedListActionTypes.Fetched,
      });

      return;
    }

    dispatch<IMarkedListFetched>({
      data: formatMarkedList(markedList, {
        villageListSummary,
        pageData: {
          feature: getState().seo.pageData?.seoData?.feature,
          totalItems: getState().villageList.totalItems,
        },
      }),
      type: MarkedListActionTypes.Fetched,
    });
  };
}

export type TMarkedListAction = IMarkedListFetched;
